<button type="button" class="city-finder-link" (click)="open()">
  {{ linkLabel }}
</button>

<pr-modal #finderModal display="neutral" clazz="pr-city-finder-modal">
  <div class="city-finder">
    <div class="city-finder__header">
      <h3 class="city-finder__title">{{ title }}</h3>
      <p class="city-finder__hint">
        Saisissez un nom de ville <strong>ou</strong> un code postal. Les
        résultats proviennent du référentiel officiel INSEE / La Poste utilisé
        par Swisslife.
      </p>
    </div>

    <div class="city-finder__search">
      <input
        type="text"
        class="city-finder__input"
        placeholder="Ex : Paris, Lyon, 75001…"
        [ngModel]="searchTerm"
        (ngModelChange)="onSearch($event)"
      />
    </div>

    <ul class="city-finder__results">
      @for (item of results; track item) {
        <li class="city-finder__result" (click)="select(item)">
          <span class="city-finder__zip">{{ item.zipCode }}</span>
          <span class="city-finder__city">{{ item.city }}</span>
        </li>
      } @empty {
        <li class="city-finder__empty">
          Aucune ville ne correspond à votre recherche.
        </li>
      }
    </ul>

    <div class="city-finder__footer">
      <button type="button" class="city-finder__close" (click)="close()">
        Fermer
      </button>
    </div>
  </div>
</pr-modal>
